module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag07_0279AT.64095f11.jpg";